import gql from "graphql-tag"

/**
 * 注文チャット（監視）用 GraphQL 契約。
 * admin の viewerType は "ADMIN"（全チャンネル閲覧）。
 * 契約書: CHAT_CONTRACT.md
 */

export type ChatChannel = "GROUP" | "USER_RIDER" | "RIDER_STORE" | "USER_STORE"

export const CHANNEL_LABELS: Record<string, string> = {
  GROUP: "全員",
  USER_RIDER: "お客様・配達員",
  RIDER_STORE: "配達員・店舗",
  USER_STORE: "お客様・店舗",
}

export const channelLabel = (channel: string): string =>
  CHANNEL_LABELS[channel] || channel

export type SenderType = "USER" | "RIDER" | "STORE" | "ADMIN"

export const SENDER_LABELS: Record<string, string> = {
  USER: "お客様",
  RIDER: "配達員",
  STORE: "店舗",
  ADMIN: "管理",
}

export type OrderChatMeta = {
  orderId: string
  policy: string
  viewerType: string
  channels: string[]
}

export type OrderMessage = {
  _id: string
  order: string
  channel: string
  senderType: string
  senderId: string
  senderName: string
  text: string
  image: string
  readByUser: string
  readByRider: string
  readByStore: string
  createdAt: string
}

export type OrderMessageAdded = {
  _id: string
  order: string
  channel: string
  senderType: string
  senderId: string
  senderName: string
  text: string
  image: string
  createdAt: string
}

export type OrderTyping = {
  orderId: string
  channel: string
  senderType: string
  senderName: string
  isTyping: boolean
}

export const ORDER_CHAT_META = gql`
  query OrderChatMeta($orderId: String!) {
    orderChatMeta(orderId: $orderId) {
      orderId
      policy
      viewerType
      channels
    }
  }
`

export const ORDER_MESSAGES = gql`
  query OrderMessages($orderId: String!, $channel: String) {
    orderMessages(orderId: $orderId, channel: $channel) {
      _id
      order
      channel
      senderType
      senderId
      senderName
      text
      image
      readByUser
      readByRider
      readByStore
      createdAt
    }
  }
`

export const SEND_ORDER_MESSAGE = gql`
  mutation SendOrderMessage($orderId: String!, $channel: String!, $text: String, $image: Upload) {
    sendOrderMessage(orderId: $orderId, channel: $channel, text: $text, image: $image) {
      _id
      channel
      senderType
      senderName
      text
      image
      createdAt
    }
  }
`

export const ORDER_MESSAGE_ADDED = gql`
  subscription OrderMessageAdded($orderId: String!, $viewerType: String) {
    orderMessageAdded(orderId: $orderId, viewerType: $viewerType) {
      _id
      order
      channel
      senderType
      senderId
      senderName
      text
      image
      createdAt
    }
  }
`

export const ORDER_TYPING = gql`
  subscription OrderTyping($orderId: String!, $viewerType: String) {
    orderTyping(orderId: $orderId, viewerType: $viewerType) {
      orderId
      channel
      senderType
      senderName
      isTyping
    }
  }
`

export type OrderChatMetaResponse = { orderChatMeta: OrderChatMeta }
export type OrderMessagesResponse = { orderMessages: OrderMessage[] }
export type OrderMessageAddedResponse = { orderMessageAdded: OrderMessageAdded }
export type OrderTypingResponse = { orderTyping: OrderTyping }
